// The portal's calls to /api/pricing/tlds (features/pricing): what the reseller sells each TLD
// KilatDomain offers for. Shapes from packages/contracts.
import {
  ListResellerTldsResponse,
  ResellerTldResponse,
  type SetRetailPricesRequest,
  type SetTldEnabledRequest,
} from "@kilat/contracts/reseller-pricing";
import type { MoveTldRequest } from "@kilat/contracts/tld-pricing";
import { api } from "@/lib/api-client";

const TLDS = "/api/pricing/tlds";

export const listTldPricing = () => api.request(TLDS, { schema: ListResellerTldsResponse });

export const setRetailPrices = (tldId: string, prices: SetRetailPricesRequest) =>
  api.request(`${TLDS}/${tldId}/prices`, { method: "PUT", body: prices, schema: ResellerTldResponse });

export const setTldEnabled = (tldId: string, choice: SetTldEnabledRequest) =>
  api.request(`${TLDS}/${tldId}`, { method: "PATCH", body: choice, schema: ResellerTldResponse });

export const moveTld = (tldId: string, move: MoveTldRequest) =>
  api.request(`${TLDS}/${tldId}/move`, { method: "POST", body: move, schema: ListResellerTldsResponse });
